module.exports = __webpack_public_path__ + "static/media/postgres.45e46bc0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/postgres.svg
// module id = 66
// module chunks = 0